import { hasCapability, type User } from "../base";

export const activityLog = {
  read: (user: User) => hasCapability(user, "activityLog.read"),
};
